import { GameRequest } from '@api/selfServe';
import { SelfServeDataAccessStatus } from '@constants/constants';

export const pendingAccessResponse = (
  gameRequest: GameRequest,
  payload: {
    companyName: string;
    companyAddress: string;
    signingAuthorityName: string;
    signingAuthorityEmail: string;
    signingAuthorityTitle: string;
  },
): GameRequest[] => {
  return [
    {
      ...gameRequest,
      requestStatus: SelfServeDataAccessStatus.PENDING_ACCESS,
      companyName: payload.companyName,
      companyAddress: payload.companyAddress,
      signingAuthorityName: payload.signingAuthorityName,
      signingAuthorityEmail: payload.signingAuthorityEmail,
      signingAuthorityTitle: payload.signingAuthorityTitle,
    },
  ];
};
